import { render, staticRenderFns } from "./MinisiteDeclareResultConfirmation.vue?vue&type=template&id=374a515e&scoped=true&"
import script from "./MinisiteDeclareResultConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisiteDeclareResultConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteDeclareResultConfirmation.vue?vue&type=style&index=0&id=374a515e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a515e",
  null
  
)

export default component.exports